import React, { Component } from 'react'
import PropTypes from 'prop-types'
import UUID from 'uuid'
import { ListStation } from "./ListStation";

const $ = window.$

class ListComponent extends Component {

	constructor(props) {
		super(props)
	}

	componentDidMount() {
		$('.collapsible').collapsible()
	}

	componentDidUpdate() {
		$('.collapsible').collapsible()
	}

	getCheckBox = (dataId, isChecked, isToogle) => {
		if (this.props.generalFunction) {
			const idTmp = dataId + UUID.v4()
			if (isToogle !== null && isToogle !== undefined) {
				return (
					<div className='switch'>
						<label htmlFor={ idTmp }>
							<input checked={ isToogle } onChange={ () => this.props.generalFunction(dataId, !isToogle) }
								   type='checkbox'
								   id={ idTmp }/>
							<span className='lever'/>
						</label>
					</div>
				)
			} else if (isChecked !== null && isChecked !== undefined) {
				return (
					<div className='col s1 right-align group-input'>
						<input checked={ isChecked } className='filled-in'
							   onChange={ () => this.props.generalFunction(dataId, !isChecked) } type='checkbox'
							   id={ idTmp }/>
						<label htmlFor={ idTmp } />
					</div>
				)
			}
		}
		return null
	}
	getIcon = (data) => {
		if (data.picture) {
			return (<img className='iconeTypeResearch circle responsive-img' src={ data.picture }/>)
		} else if (data.icon) {
			return (<div className='material-icons iconeTypeResearch circle'>{ data.icon }</div>)
		}
		return ''
	}

	openModal = (id) => {
		const idModal = '#' + id
		$(idModal).modal('open')
	}

	getData() {
		return this.props.tables.map((data, i) => {
			const icon = this.getIcon(data)
			const color = data.color ? data.color : 'white'
			const checkBox = this.getCheckBox(data.id, data.isChecked, data.isToogle)
			const className = checkBox ? 's11' : 's12'

			const title = (() => {
				if (data.modal) {
					return (
						<div className='row no-margin'>
							<div className='col s11 no-padding truncate'>
								<span className='truncate'><b>{ data.title }</b></span>
							</div>
							<div className='col s1 no-padding'>
								{ data.modal }
								<i className='material-icons help-icon'
								   onClick={ () => this.openModal(data.idModal) }>info_outline</i>
							</div>
						</div>
					)
				}
				return (
					<div className='row no-margin'>
						<div className='col s12 no-padding '>
							<span className='truncate'><b>{ data.title }</b></span>
						</div>
					</div>
				)
			})()
			const iconPanel = (() => {
				if (icon) {
					return (
						<div className='col s2 no-padding'>
							<div className='iconeTypeResearchWrapper'>{ icon }</div>
						</div>
					)
				}
				return null
			})()
			const classNameTitle = iconPanel ? 's10' : 's12'
			const list = (() => {
				if (data.lightMode) {
					return (<ListStation stations={ data.component }/>)
				}
				return (<div className='collapsible-body no-padding no-margin'>
					{ data.component }
				</div>);
			})()
			return (
				<div className='row no-margin' style={ { width: '100%' } }>
					<ul className='collapsible no-margin' data-collapsible='expandable'>
						<li key={ i + 2000 }>
							<div className='collapsible-header valign-wrapper ' style={ { backgroundColor: color } }>
								<div className={ `col no-padding ${ className }` }>
									<div className='row no-margin' style={ { width: '100%' } }>
										{ iconPanel }
										<div className={ 'col no-padding site-type-title ' + classNameTitle }>
											{ title }
										</div>
									</div>
								</div>
								{ checkBox }
							</div>
							{ list }
						</li>
					</ul>
				</div>
			)
		})
	}

	render() {
		return (
			<ul style={ { width: '100%' } } className='no-margin no-padding'>
				<li>{ this.getData() }</li>
			</ul>
		)
	}
}

ListComponent.propTypes = {
	tables: PropTypes.arrayOf(PropTypes.shape({
		title: PropTypes.string,
		component: PropTypes.object,
		modal: PropTypes.object,
		idModal: PropTypes.string,
		color: PropTypes.string,
		id: PropTypes.number,
		isChecked: PropTypes.bool,
		isToogle: PropTypes.bool,
		icon: PropTypes.string,
		picture: PropTypes.string
	})),
	generalFunction: PropTypes.func
}

ListComponent.defaultProps = {
	tables: []
}

export default ListComponent



// WEBPACK FOOTER //
// ./src/components/list/ListComponent.js